import { render, staticRenderFns } from "./edit-logistic-info.vue?vue&type=template&id=58eabaf7&scoped=true"
import script from "./edit-logistic-info.ts?vue&type=script&lang=ts&external"
export * from "./edit-logistic-info.ts?vue&type=script&lang=ts&external"
import style0 from "./edit-logistic-info.scoped.scss?vue&type=style&index=0&id=58eabaf7&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58eabaf7",
  null
  
)

export default component.exports